enum AppAttributeGroup {
  ImOperator = "ImOperator",
  ImSupervisor = "ImSupervisor",
  ImViewer = "ImViewer",
}
export default AppAttributeGroup;
